import * as z from "zod/v4";

/**
 * Resolve the merchant team id that owns each given fulfillment group. 3PL
 * flows (e.g. the pick session scan handler) use the map to attribute a scan
 * to a specific merchant and evaluate per-merchant policies like the strict
 * license-plate bypass list.
 *
 * Returns `null` for any id that doesn't resolve to a fulfillment group whose
 * `team` is visible to the caller.
 */
export const getFulfillmentGroupMerchantTeamIds = {
  name: "getFulfillmentGroupMerchantTeamIds" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()).max(500) }),
  output: z.object({
    merchantTeamIdsByGroupId: z.record(z.string(), z.string().nullable()),
  }),
};
